import React from "react";

const TabsHeading = ({ list, actTab, setActTab }) => {
  return (
    <div className="row mt-3 mx-0">
      <div className="col-md-4 justify-content-center mx-auto d-flex  ">
        <div className="bttn-tabs">
          <ul>
            {list.map((menu, index) => {
              return (
                <li
                  key={menu}
                  className={`${
                    actTab === menu ? "active tabs" : "tabs"
                  } text-capitalize`}
                  onClick={() => {
                    setActTab(menu);
                  }}
                >
                  {menu}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TabsHeading;
